import { SagaIterator } from "redux-saga";
import { all, fork } from "redux-saga/effects";

import mainSaga from "./main";

export default function* appSaga(): SagaIterator {
  yield all([fork(mainSaga)]);
}
